module.exports = __webpack_public_path__ + "img/camilasaez.5c90ada7.jpg";